// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"2987ac1b","446":"ec5bac31","589":"3372b373","812":"3506356d","913":"26131e01"}[chunkId] + ".chunk.js";
};